import { Button } from "@components/controls/Button"
import { ChoosePlan } from "@features/accounts/components/ChoosePlan"
import { useIsLoggedIn } from "@features/accounts/hooks/useAuth"
import { defineBlock, EditableText } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Become a Member",
  category: "text",
  tags: ["root"],
  icon: "admin-users",
  keywords: ["membership", "join", "signup"],
  conditions: {
    postTypes: ["page", "article", "resource"],
  },
}

export default defineBlock("subpage/become-a-member", (props) => {
  const loggedIn = useIsLoggedIn()
  return (
    <>
      <ChoosePlan data={props} intent="join" loggedIn={loggedIn} />
      {(!loggedIn || env.admin) && (
        <div className="flex flex-col gap-2 items-start">
          <EditableText store="content" as="p" className="is-style-title-large mt-8" placeholder="Enter text" />
          <Button href={`/join/`} variant="charcoal">
            <EditableText store="buttontext" as="span" defaultValue="Become a member" />
          </Button>
        </div>
      )}
    </>
  )
})
